export interface GetPaymentSessionStatusResponse {
  id: string;
  type: string;
  status: PaymentSessionStatus;
  receiptdata: PaymentSessionReceiptData;
  balance: number;
}

export enum PaymentSessionStatus {
  IN_PROGRESS = 'InProgress',
  APPROVED = 'Approved',
  DECLINED = 'Declined',
  ERROR = 'Error',
}

export interface PaymentSessionReceiptData {
  Cashier: PaymentSessionReceiptDataItem[];
  Customer: PaymentSessionReceiptDataItem[];
}

export interface PaymentSessionReceiptDataItem {
  Key: string;
  Name: string;
  Value: string;
}
